import { FC, Fragment, MouseEventHandler } from 'react';
import { BKJButton, Flex } from '@bookjane2/bookjane-design-library';
import { H3 } from 'components/Typography';
import { BKJSideModalFooter } from 'components/BKJSideModalFooter';
import { AutoMargin } from 'components/AutoMargin';
import { useEditViewContext } from 'modals/ShiftModal/src/views/EditView/EditView.context';
import { useTranslation } from 'hooks/useTranslation';
import { Text } from 'modals/ShiftModal/src/views/DetailView/DetailView.styled';

export const PublishEditsWarningView: FC = () => {
  const { t } = useTranslation();
  const { isSubmitting, onSubmit } = useEditViewContext();

  return (
    <Fragment>
      <Flex flexDirection="column" padding="32px" flex="1">
        <Flex padding="0 0 32px 0">
          <H3 color="TextDarkGrey">{t('shift_modal:PUBLISH_EDITS_CONFIRMATION')}</H3>
        </Flex>
        <Text>{t('shift_modal:PUBLISH_EDITS_CALL_OUT_RESTART_WARNING')}</Text>
      </Flex>
      <BKJSideModalFooter>
        <AutoMargin />
        <BKJButton
          variant="PurpleSolid"
          width="180px"
          type="button"
          isLoading={isSubmitting}
          onClick={onSubmit as unknown as MouseEventHandler<HTMLButtonElement>}
        >
          {t('shift_modal:PUBLISH_EDITS')}
        </BKJButton>
      </BKJSideModalFooter>
    </Fragment>
  );
};
